import { render } from "./CxSelector.vue?vue&type=template&id=28ff9db4"
import script from "./CxSelector.vue?vue&type=script&lang=js"
export * from "./CxSelector.vue?vue&type=script&lang=js"

import "./CxSelector.vue?vue&type=style&index=0&id=28ff9db4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__